import styled from "styled-components";  
import { IModalStyles } from "../interfaces";

export const DisplayFade = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #152837;
  transition: opacity 0.1s linear;
  opacity: 0.75;
`;
export const ModalWrapper = styled.div<IModalStyles>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  outline: 0;
  display: block;
  text-align: center;
  opacity: 1;
  overflow-y: auto;
  padding: 40px 0px;
  &::before {
    content: "";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }
  .header-sub-bar {
    height: 60px;
    background-color: #f4f7fb;
    text-align: center;
    width: 100%;
    padding: 15px;
    font-size: 20px;
    font-weight: 600;
  }
`;
export const DialogBox = styled.div<IModalStyles>`
  display: inline-block;
  text-align: ${(props) => props.textAlign || "left"};
  vertical-align: middle;
  margin: auto;
  width: ${(props) => props.width || "500px"};
`;
export const ModalContent = styled.div<IModalStyles>`
  border: none;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  position: relative;
  background-color: ${(props) => props.bgColor || "#fff"};
  border-radius: 6px;
  outline: 0;
`;
export const ModalHeader = styled.div<IModalStyles>`
  height: 56px;
  border-radius: 4px 4px 0px 0px;
  background-color: ${(props) => props.headerColor || "rgb(120, 155, 182)"};
  text-align: center;
  border-bottom: none;
  padding: 15px;
  /* ::before {
        display: table;
        content: ' ';
        box-sizing: border-box;
    }
    ::after {
        display: table;
        content: ' ';
        clear: both;
        box-sizing: border-box;
    } */
  .header-title {
    color: rgb(255, 255, 255);
    font-size: ${(props) => props.titleFontSize || "18px"};
    font-weight: 600;
    line-height: normal;
    text-align: center;
    max-width: 90ch;
    width:auto;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
export const CrossBtn = styled.div<IModalStyles>`
  &.close-button {
    /* padding: 13px; */
    background: #fff;
    border-radius: 50%;
    opacity: 1;
    box-shadow: 0 2px 4px 0 rgba(204, 204, 204, 0.5);
    color: ${(props) => props.color || "rgb(120, 155, 182)"};
    line-height: 36px;
    height: 35px;
    width: 35px;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(16px, -16px);
    z-index: 9;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
  }
`;
export const ModalBody = styled.div<IModalStyles>`
  min-height: ${(props) => `${props.minHeight}`};
  max-height: ${(props) => `calc(100vh - ${props.maxHeight})`};
  height: ${(props) => props.bodyHeight || "auto"};
  background: ${(props) => `${props.bgColor}`};
  /* word-break: break-word; */ //Creating issues with long words
  overflow-y: ${(props) => props.scrollable || "auto"};
  padding: ${(props) => `${props.bodyPadding}`};
  &::-webkit-scrollbar {
    width: 0.3em;
    height: 0.4em;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    outline: 1px solid slategrey;
    /* background-color: ${(props) =>
      props.scrollColor || " rgb(120, 155, 182)"}; */
    background-color: ${(props) =>
      props.redHeader || props.greenHeader
        ? "#1528376b"
        : props.scrollColor || "rgb(120, 155, 182)"};
  }
  /* &.overflow-hide {
        overflow: hidden;
    } */
`;

export const ModalFooter = styled.div<IModalStyles>`
  height: ${(props) => props.height || "55px"};
  border-top: 1px solid ${(props) => props.border || "rgb(221, 221, 221)"};
  border-radius: 0px 0px 4px 4px;
  background-color: ${(props) => props.bgColor || "rgb(248, 248, 248)"};
  text-align: center;
  padding: ${(props) => props.padding || "12px"};
`;
export const CustomFooter = styled.div``;

export const ModalCustomHeader = styled.div<IModalStyles>`
  height: auto;
  background: ${(props) => props.bgColor || "none"};
  text-align: left;
  padding: ${(props) => props.padding || "15px 15px 15px 20px"};
  color: rgb(85, 85, 85);
  font-weight: 600;
  font-size: 20px;
`;
